/**
 *  @class
 *  @function CollectionTabs
 */

if (!customElements.get('collection-tabs')) {
  class CollectionTabs extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      setTimeout(() => {
        const buttons = Array.from(this.querySelectorAll('button'));
        const sectionHeader = this.closest('.section-header');
        if (!sectionHeader) return; // Ensure the existence of the section header
        const links = sectionHeader.querySelectorAll('.linked-to-tab');
        this.target = this.dataset.target;
        this.themeScroll = sectionHeader.nextElementSibling;

        if (this.classList.contains('collection-tabs__list')) {
          this.setupUnderline(buttons);
        }

        buttons.forEach((button, i) => {
          button.addEventListener('click', (event) => {
            this.toggleButtons(buttons, i);
            this.toggleLinks(links, i);
            if (button.dataset.collection) {
              this.toggleCollection(button.dataset.collection);
            }
            this.updateIndicator();
            this.syncShopAllButtons();
            event.preventDefault();
          });
        });

        if (this.dataset.sectionId) {
          requestAnimationFrame(() => this.syncShopAllButtons());
        }

        if (Shopify.designMode) {
          this.addEventListener('shopify:block:select', (event) => {
            const index = buttons.indexOf(event.target);
            if (index !== -1) {
              buttons[index].dispatchEvent(new Event('click'));
            }
          });
        }
      }, 10);
    }

    setupUnderline(buttons) {
      this._tabButtons = buttons;

      this._rule = document.createElement('div');
      this._rule.className = 'collection-tabs__rule';

      this._indicator = document.createElement('div');
      this._indicator.className = 'collection-tabs__indicator';

      this.appendChild(this._rule);
      this.appendChild(this._indicator);

      const schedule = () => requestAnimationFrame(() => this.updateIndicator());
      schedule();

      this._onResize = () => schedule();
      window.addEventListener('resize', this._onResize);

      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(schedule);
      }

      if (typeof ResizeObserver !== 'undefined') {
        this._ro = new ResizeObserver(schedule);
        this._ro.observe(this);
      }
    }

    updateIndicator() {
      if (!this._indicator) return;

      if (window.innerWidth < 768) {
        this._indicator.style.width = '0px';
        return;
      }

      const active = (this._tabButtons || []).find((btn) => btn.classList.contains('active'));
      if (!active) {
        this._indicator.style.width = '0px';
        return;
      }

      const hostRect = this.getBoundingClientRect();
      const activeRect = active.getBoundingClientRect();

      const overflow = 12;
      const left = activeRect.left - hostRect.left + this.scrollLeft - overflow;
      const width = activeRect.width + overflow * 2;

      this._indicator.style.width = `${width}px`;
      this._indicator.style.transform = `translateX(${left}px)`;
    }

    syncShopAllButtons() {
      const sectionId = this.dataset.sectionId;
      if (!sectionId) return;

      const sectionEl = document.getElementById(`shopify-section-${sectionId}`);
      if (!sectionEl) return;

      const desktop = sectionEl.querySelector('.collection-tabs__shop-all--desktop');
      const mobile = sectionEl.querySelector('.collection-tabs__shop-all--mobile');
      const mobileWrap = sectionEl.querySelector('.collection-tabs__mobile-cta');
      if (!desktop && !mobile) return;

      const active = this.querySelector('button.collection-tabs__list-link.active');
      if (!active) return;

      const hasMore = active.dataset.hasMore === 'true';
      const url = active.dataset.collectionUrl || '#';

      const sectionFallback = (this.dataset.sectionViewAllFallback || '').trim();
      let label = (active.dataset.viewAllLabel || '').trim();
      if (!label) label = sectionFallback;
      if (!label) label = (active.dataset.viewAllDefaultLabel || '').trim();

      const bg = active.dataset.viewAllBg || '';
      const tc = active.dataset.viewAllText || '';

      const apply = (el) => {
        if (!el) return;
        if (!hasMore) {
          el.setAttribute('hidden', '');
          return;
        }
        el.removeAttribute('hidden');
        el.setAttribute('href', url);
        el.textContent = label;
        if (bg) {
          el.style.setProperty('background-color', bg, 'important');
          el.style.setProperty('background', bg, 'important');
          el.style.setProperty('border-color', bg, 'important');
        }
        if (tc) el.style.setProperty('color', tc, 'important');
      };

      apply(desktop);
      apply(mobile);

      if (mobileWrap) {
        if (!hasMore) mobileWrap.setAttribute('hidden', '');
        else mobileWrap.removeAttribute('hidden');
      }

      sectionEl.dispatchEvent(new CustomEvent('collection-tabs:shop-all-updated', { bubbles: true }));
    }

    disconnectedCallback() {
      if (this._onResize) window.removeEventListener('resize', this._onResize);
      if (this._ro) this._ro.disconnect();
    }

    toggleButtons(buttons, index) {
      buttons.forEach((button) => button.classList.remove('active'));
      buttons[index].classList.add('active');
    }

    toggleLinks(links, index) {
      if (links.length) {
        links.forEach((link) => link.classList.remove('active'));
        links[index].classList.add('active');
      }
    }

    toggleCollection(handle) {
      const slider = document.getElementById(this.target);
      if (!slider) return; // Ensure the existence of the slider
      const products = slider.querySelectorAll(`.collection-tabs--product:not([data-collection="${handle}"])`);
      const activeProducts = slider.querySelectorAll(`[data-collection="${handle}"]`);

      products.forEach((product) => product.classList.remove('carousel__slide'));
      activeProducts.forEach((product) => product.classList.add('carousel__slide'));

      this.themeScroll.init();
      this.themeScroll.querySelector('.theme-scroll--inner').scroll({
        top: 0,
        left: 0
      });

      // Inicializar swatches después de cambiar de tab
      if (window.initializeProductSwatches) {
        setTimeout(() => {
          window.initializeProductSwatches();
          console.log('Swatches inicializados después de cambiar tab de colección');
        }, 100);
      }
    }
  }
  customElements.define('collection-tabs', CollectionTabs);
}